import React, { Component } from 'react';
import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import './_section-portfolio.scss';

import HOLDER from "../../static/placeholder.gif";
const PortfolioItem = (props) => (
	<div className="col-md-4">
		<a href={'/portfolio-item?'+'title='+props.title+'&url='+props.link+'&description='+props.description} className="portfolio-item">
			<img src={props.image} />
			<p><strong>{props.content}</strong> • <em>{props.social}</em> <i className="fas fa-chevron-right"></i></p>
		</a>
	</div>
)

class NewsListing extends Component {
	
	constructor(props) {
	        super(props);
	        this.toggleClass = this.toggleClass.bind(this);
	        this.state = {
	            sectionActive: false
	        };
	    }
	    
	  toggleClass(event) {
		    
	        const currentState = this.state.sectionActive;
	        this.setState({ sectionActive: !currentState });
	        
	        if (!this.state.sectionActive) {
		        document.body.classList.add('portfolio-open');
	        } else {
		        document.body.classList.remove('portfolio-open'); 
	        }
	        
	         event.preventDefault();
			 const elementTop = this.gate.offsetTop
			
			 //setTimeout(() => window.scrollTo(0, elementTop), 1000);
	    };
	    
	    
	
  render() {
	 // console.log('props in portfolio', this.props);
	  
	  var size = 6;
		var items3 = this.props.data.parts.slice(0, size).map(item => {
		    return <PortfolioItem image={item.image} title={item.title} content={item.content} social={item.social} link={item.link} key={item.title} description={item.description} />
		})
		
		var itemsRest = this.props.data.parts.slice(6, 20).map(item => {
		    return <PortfolioItem image={item.image} title={item.title} content={item.content} social={item.social} link={item.link} key={item.title} description={item.description} />
		})
	  
	  return (
		  <section className={this.state.sectionActive ? 'section-portfolio section-container active' : 'section-portfolio section-container'} id="portfolio" name="portfolio" ref={elem => (this.gate = elem)}>
		    <div className="container">
			      <div className="row">
			        <div className="col-12">
			          <h2><Link href="#portfolio" onClick={this.toggleClass} className="back-but" to="portfolio" smooth={true} offset={300} duration={600} delay={600}><i className="fas fa-times"></i></Link> {this.props.data.title}</h2>
			       </div>
				</div>
				<div className="row">
					{items3}
				</div>
				<div className="all-the-others">
					<div className="row">
						{itemsRest}
					</div>


				</div>
				 <div className="row">
			        <div className="col-12 text-center">
			        	<Link href="#portfolio" onClick={this.toggleClass} className="btn btn-primary" to="portfolio" smooth={true} offset={100} duration={600} delay={600}> {this.props.data.ctabutton}</Link>
			        </div>
			    </div>
		    </div>
		  </section>) 
  };
}
export default NewsListing;



// WEBPACK FOOTER //
// ./src/components/section-portfolio/index.js